export type RegistrationFieldDefaultType = 'None' | 'Sex' | 'Date' | 'PostalCode' | 'Boolean';

export interface IRegistrationFieldDefinition {
    fieldKey: string;
    mandatory: boolean;
    defaultType: RegistrationFieldDefaultType;
}

export interface IRegistrationFieldConfigItem {
    fieldKey: string;
    hidden: boolean;
    defaultValue?: string | null;
}

export interface IRegistrationFieldsConfig {
    availableFields: IRegistrationFieldDefinition[];
    config: IRegistrationFieldConfigItem[];
    sexes: { id: number; name: string }[];
}

export interface IRegistrationFieldsConfigInput {
    config: IRegistrationFieldConfigItem[];
}

// Recognizable sentinel default for a hidden birth date (AMI-612).
export const DEFAULT_HIDDEN_BIRTH_DATE = '1900-01-01';

export const isValidRegistrationDefault = (
    type: RegistrationFieldDefaultType,
    value: string | null | undefined,
): boolean => {
    switch (type) {
        case 'Sex':
            return !!value && Number(value) > 0;
        case 'Date':
            return !!value && !isNaN(new Date(value).getTime());
        case 'PostalCode':
            return (
                !!value &&
                /^[0-9]{5}(?:-[0-9]{4})?$|^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/.test(value)
            );
        case 'Boolean':
            return value === 'true' || value === 'false';
        default:
            return true;
    }
};
